import Socket from 'websocket-client';
import React from 'react'

import config from '../config';
import { requestContentGroups, requestSecurityRoles } from '../AuthWrapper';
import store from '../redux/store'
import actions from '../redux/actions'
import { NOTIFICATION_INFO, NOTIFICATION_WARNING } from '../common/components/notifications/types';
import wsLogger from './ws-logger';
import wsProbe from './ws-probe';

const setUser = user => store.dispatch(actions.user.setUser({user}))
const setContentGroups = contentGroups => store.dispatch(actions.user.setContentGroups({contentGroups}))
const setSecurityRoles = securityRoles => store.dispatch(actions.user.setSecurityRoles({securityRoles}))

const WebsocketAdapter = (clientID, socketErrorBus, userID) => {
    if (store.getState().data.websocket !== null) {
        // return the existing websocket if there is one already setup
        return store.getState().data.websocket
    }
    var drone = new ScaleDrone(config.scaledroneKey);
    var socket = Socket(clientID, drone);
    const globalSocket = Socket('GlobalCC', drone)

    globalSocket.on('open', err => {
        if (err) {
            console.error('global socket was setup:', err)
        }
    })
    globalSocket.on('data', ev => {
        // example ev = {messageType: 'version_update_master', message: 'new version of control center is now available'}
        // example ev = {messageType: 'version_update_staging', message: 'new version of dev project is now available'}
        const acceptedMessageType = location.host === 'controlcenter-stage' ? 'version_update_staging' : 'version_update_master'
        if (ev && ev.messageType && ev.messageType === acceptedMessageType) {
            store.dispatch(actions.alerts.createAlert({
                permanent: true,
                variant: NOTIFICATION_WARNING,
                component: <div>There is a new version of the control center! <a href={window.location}>Click Here to reload</a></div>
            }))
        } else if (ev && ev.messageType && ev.messageType === 'message') {
            store.dispatch(actions.alerts.createAlert({
                permanent: false,
                variant: NOTIFICATION_INFO,
                component: <div>{ev.message}</div>
            }))
        }
    })

    if (typeof window !== 'undefined') {
        window.wsLog = wsLogger;
    }
    if (process.env.NODE_ENV === 'development') {
        window.socket = socket;
    }
    socket.on('users', function functionName(ev) {
        // update redux store on user update
        if (userID == ev.data.users.userId) {
            setUser(ev.data.users)
        }
        requestContentGroups(clientID, setContentGroups)
        requestSecurityRoles(clientID, setSecurityRoles)
    })

    socket.on('error', function functionName () {
        wsProbe.sdk('error')
        if (process.env.NODE_ENV === 'development') {
            console.log('socket:error');
        }
        socketErrorBus.emit('restart');
    });

    socket.on('close', function functionName () {
        wsProbe.sdk('close')
        if (process.env.NODE_ENV === 'development') {
            console.log('socket:close');
        }
        socketErrorBus.emit('restart');
    });
    socket.on('open', function storeSocket() {
        wsProbe.sdk('open')
        store.dispatch(actions.data.setWebsocket({websocket: {socket, drone}}))
    })
    socket.on('data', function functionName(ev) {
        // Before the health filter -- the probe needs to see health echoes
        // precisely because they are the traffic we are trying to remove.
        wsProbe.inbound(ev)
        if (ev && ev.action && ev.action.method !== 'health') {
            wsLogger.log(ev)
            // Lightweight focused trace for AD project messages. Logs the
            // raw arrival (before reducer routing) so we can tell whether a
            // missing UI update is "ws didn't arrive" or "ws arrived but the
            // reducer dropped it". The reducer itself logs the next stage.
            if (ev.action.method === 'ad-studio-projects') {
                console.log(
                    '[AD-WS] recv',
                    ev.action.type,
                    'eventID=' + (ev.data && ev.data.eventID),
                    'projectID=' + (ev.data && ev.data.id),
                    'revision=' + (ev.data && ev.data.revision)
                )
            }
            store.dispatch({
                type: `WEBSOCKET_DATA_${ev.action.method}_${ev.action.type}`,
                payload: ev
            })
        }
    })

    return {
        drone: drone,
        socket: socket
    };
};

export default WebsocketAdapter